export const USER_TYPE_OPTIONS = [
  { label: "SUPER_ADMIN", value: "SUPER_ADMIN" },
  { label: "ADMIN", value: "ADMIN" },
  { label: "ACCOUNT", value: "ACCOUNT" },
  // Must match the backend Role enum exactly: a membership saved as REFERRAL_USER showed a blank
  // User Type here for every invited referral partner.
  { label: "REFERRAL", value: "REFERRAL_USER" },
  { label: "USER", value: "USER" },
];

export const userHasOrgMembership = (user, orgId) => {
  if (orgId == null) {
    return true;
  }
  const parsedOrgId = typeof orgId === "string" ? parseInt(orgId, 10) : orgId;
  if (user?.memberships?.length) {
    return user.memberships.some((membership) => membership.orgId === parsedOrgId);
  }
  return user?.organization?.id === parsedOrgId;
};

export const getRoleForOrg = (user, orgId) => {
  const parsedOrgId = typeof orgId === "string" ? parseInt(orgId, 10) : orgId;
  const membership = user?.memberships?.find((item) => item.orgId === parsedOrgId);
  if (membership?.role) {
    return typeof membership.role === "string" ? membership.role : membership.role?.name;
  }
  return user?.type;
};

export const formatUserOrganizations = (user) => {
  if (user?.memberships?.length) {
    return user.memberships
      .map((membership) => membership.orgName)
      .filter(Boolean)
      .join(", ");
  }
  return user?.organization?.name || "-";
};

export const roleValueFromMembership = (membership) => {
  if (!membership?.role) {
    return "USER";
  }
  return typeof membership.role === "string" ? membership.role : membership.role?.name || "USER";
};

export const membershipRowsFromApi = (memberships = [], consultancyList = []) => {
  return memberships.map((membership) => {
    const org = consultancyList.find((item) => item.id === membership.orgId);
    return {
      orgId: membership.orgId,
      orgName: membership.orgName || org?.name || `Org #${membership.orgId}`,
      membershipId: membership.membershipId ?? membership.id ?? null,
      role: roleValueFromMembership(membership),
      permissionKeys: membership.permissionKeys || [],
    };
  });
};

export const buildMembershipPayload = (membershipRows = []) =>
  membershipRows.map((row) => ({
    orgId: row.orgId,
    role: row.role,
    permissionKeys: row.permissionKeys || [],
  }));

export const createEmptyMembershipRow = (org, role = "USER") => ({
  orgId: org.id,
  orgName: org.name,
  membershipId: null,
  role,
  permissionKeys: [],
});
